<a class="c-blue-1" *ngIf="(evseToDisplay | async) as evse; else noData" routerLink="/evses/evse/{{evse.id}}"  [queryParams]="{fid: fleetId}" style="cursor: pointer">{{evse | evseName}}</a>
<ng-template #noData>ID[{{evseId}}]</ng-template>
